import { type Color } from "components/common/BaseLabel/BaseLabel";

export class LabelColors {
  static readonly FREE: Color = "darker-green";
  static readonly TRIAL_STARTED: Color = "green-accent";
  static readonly PURCHASED: Color = "green-accent";
  static readonly EXPIRED: Color = "red-accent";
  static readonly ARCHIVED: Color = "black";
}

export type PackLabel = {
  name: string;
  color: Color;
};

export const PACK_LABELS: Record<string, PackLabel> = {
  archived: { name: "Archived", color: LabelColors.ARCHIVED },
  trialStarted: { name: "Trial Started", color: LabelColors.TRIAL_STARTED },
  trialEnded: { name: "Trial Ended", color: LabelColors.EXPIRED },
  freeAdded: { name: "Free • Added", color: LabelColors.FREE },
  freeExpired: { name: "Free • Expired", color: LabelColors.EXPIRED },
  expired: { name: "Expired", color: LabelColors.EXPIRED },
  purchased: { name: "Purchased", color: LabelColors.PURCHASED },
};
